var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 12C5.18 12 4.405 11.8425 3.675 11.5275C2.945 11.2125 2.3075 10.7825 1.7625 10.2375C1.2175 9.6925 0.7875 9.055 0.4725 8.325C0.1575 7.595 0 6.82 0 6C0 5.17 0.1575 4.3925 0.4725 3.6675C0.7875 2.9425 1.2175 2.3075 1.7625 1.7625C2.3075 1.2175 2.945 0.7875 3.675 0.4725C4.405 0.1575 5.18 0 6 0C6.83 0 7.6075 0.1575 8.3325 0.4725C9.0575 0.7875 9.6925 1.2175 10.2375 1.7625C10.7825 2.3075 11.2125 2.9425 11.5275 3.6675C11.8425 4.3925 12 5.17 12 6C12 6.82 11.8425 7.595 11.5275 8.325C11.2125 9.055 10.7825 9.6925 10.2375 10.2375C9.6925 10.7825 9.0575 11.2125 8.3325 11.5275C7.6075 11.8425 6.83 12 6 12ZM6 9.6C7 9.6 7.85 9.25 8.55 8.55C9.25 7.85 9.6 7 9.6 6C9.6 5 9.25 4.15 8.55 3.45C7.85 2.75 7 2.4 6 2.4C5 2.4 4.15 2.75 3.45 3.45C2.75 4.15 2.4 5 2.4 6C2.4 7 2.75 7.85 3.45 8.55C4.15 9.25 5 9.6 6 9.6Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleSmall);
export default __webpack_public_path__ + "static/media/circleSmall.ac6a4ee58b0550032babb8715971016a.svg";
export { ForwardRef as ReactComponent };